import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import TeamForm from "./teamComponents/TeamForm";

import { useCreateTeamMutation } from "store/services/teamApi";

import { useAppMeta } from "hooks";

const TeamCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Teams", path: "/app/crm/team/list" },
    { title: "New Team" },
  ];

  // RTK Query
  const [createTeam, { isLoading: creatingTeam }] = useCreateTeamMutation();

  // methods
  const handleAddTeam = async (data) => {
    try {
      await createTeam(data).unwrap();
      toast.success("Team successfully created!");
      navigate(breadcrumbs[0]?.path);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't add team!");
    }
  };

  useAppMeta("New Team");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingTeam}>
      <BreadcrumbLayout.Paper>
        <TeamForm isBusy={creatingTeam} onSubmit={handleAddTeam} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default TeamCreateScreen;
